module.exports = __webpack_public_path__ + "static/media/docDrop.02776891.jpg";